import React,{useState} from 'react';
import styled from 'styled-components'
import cn from 'classnames'

const Article2Block = styled.div`
  height: 2300px;
  padding: 150px 0px;
  background-image: url('images/paper.jpg');
  background-repeat: no-repeat;
  background-size: cover ;
  position: relative;
  z-index: 0;
    &::before {
        content: '';
        position: absolute;
        width: 100%;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0,0,0, .4);
        z-index: -1;
    }
  .linkPaper {
    position: absolute;
    top: -15px;
    left: 0;
  }
  .row {
    position: relative;
    h1 {
      font-family: 'Josefin Sans';
      font-weight: 400;
      font-size: 80px;
      padding-bottom: 150px;
      text-align: center;
      z-index: 999; 
      span {
        font-family: stussy;
        font-size: 100px;
        border-bottom: 3px solid #fff;
      }
    }
    .crown {
        position: absolute;
        width: 250px;
        top: 950px;
        left: 0px;
        transform: rotate(-10deg);
      }
    .profile {
      position: relative;
      margin-bottom: 500px ;
      > img {
        width: 700px;
        transform: rotate(-5deg);
      }
      h2 {
        position: absolute;
        font-family: 'Josefin Sans';
        font-size: 100px;
        right: 0;
        top: 90%;
        color: #fff;
        background: #000;
        /* transform: rotate(5deg); */
        transition: all .3s;
        &:hover {background:#fff; color:#000;}
      }
      p {
        position: absolute;
        right: 30px;
        top: 120%;
        line-height: 1.7em;
        /* transform: rotate(5deg); */
        > span {
          background: #000;
          color: #111;
          transition: all .3s;
          cursor: pointer;
          &:hover {color: #555;}
          &.on {
            color: #fff;
          }
        }
        .surfSection {
          position: absolute;
          top: 120%;
          left: 0;
          width: 600px;
          display: none;
          align-items: center;
          background: rgba(0,0,0,.5);
          padding:10px;
          &.on {
            display: flex;
          }
          img {
            width: 250px;
          }
          span {
            font-size: 14px;
            padding-left: 10px;
            line-height: 1.7em;
          }
        }
      }
      
      .worldTour {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
      }
    } 
    .story {
      position: relative;
      h2 {
        font-family: 'Josefin Sans';
        font-size: 120px;
        /* transform: rotate(-5deg); */
        color: #fff;
        background: #000;
        display: inline-block;
        transition: all .3s;
        &:hover {background:#fff; color:#000;}
      }
      p {
        line-height: 1.7em;
        /* transform: rotate(-5deg); */
        width: 500px;
        margin-top: 100px;
        margin-left: 30px;
        span {
          background: #000;
          color: #000;
          cursor: pointer;
          transition: all .3s;
          &:hover {
            color: #555;
          }
          &.on2 {
            color: #fff;
          }
        }
      }
      .clickImg {
        display: none;
        padding: 10px;
        background: #fff;
        margin-top: 30px;
        margin-left: 30px;
        img {
          width: 200px;
          &:nth-child(1){margin-right:10px}
        }
        &.on2 {
          display: inline-block;
        }
      }
      .poster {
        position: absolute;
        top: 90px; right: 0;
        width: 500px;
        z-index: -1;
        transform: rotate(5deg);
      }
    }
  }
`;

const Article2 = () => {

  const [on,setOn] = useState(false)
  const [on2,setOn2] = useState(false)


  return (
    <Article2Block>
      <img className='linkPaper' src="images/link_paper.png" alt='연결'/>
      <div className='row '>
        <h1>who's made <span>stussy</span></h1>
        <div className='profile'>
          <img src="images/shwan-stussy.jpeg" alt='숀 스투시'/>
          <h2>Shawn STUSSY</h2>
          <p>스투시는 1980년 SHAWN STUSSY 라는 서프보드에 열광하는 CREW가 만든 브랜드 입니다.<br/>
            스투시의 특유의 로고는 SHAWN STUSSY가 자기 이름을 대충 갈겨써서 만든 로고로 지금은 <br/> 스트릿웨어에서 
            빼놓을수 없는 브랜드로 자리 잡았지만 스투시의 시초는 캘리포니아에서 그가 티셔츠와 <br/><span className={cn({on})} onClick={()=>setOn(!on)}>서프보드</span>를 만들면서 
            시작된 작은 브랜드 였습니다. 
            <div className={cn({on},'surfSection')}>
            <img src="images/art2surf.png" alt='서핑보드'/>
            <span>1954년에 태어난 션 스투시는 서해안 서핑 문화에 빠져 자랐다고 합니다.
              그렇게 션 스투시는 캘리포니아 서퍼로 이름이 높던 자신의 사인을 프린팅한 서핑보드,티셔츠,반바지 등을 트럭에서 팔았던게스투시의 시초라고 볼 수 있습니다.
            </span>
          </div>
          </p>
          <img className='worldTour' src="images/s_sticker.gif" alt="월드투어"/>
        </div>
        <img className='crown' src="images/Slogogif.gif" alt='왕관아이콘'/>
        <div className='story'>
          <img className='poster' src="images/poster.jpeg" alt='포스터'/>
          <h2>Street fashion</h2>
          <p>스투시 싸인 로고를 기반으로 트로피칼하며 감각적인 그래픽이 돋보이는 디자인이 특징이며 로고플레이 위주의 깔끔한 디자인들도 출시한다.<br/> 
            또 다른 스트릿 패션의 근본이라고 여겨지는 브랜드인 슈프림, 베이프는 착용할 수 있는 스타일이 정통 스트릿 패션밖에 없을 정도로 범위가 꽤 한정적이지만<br/> 
            스투시는 <span className={cn({on2})} onClick={()=>setOn2(!on2)}>스트릿 패션 뿐만 아니라 고프코어(키코 스타일),캐주얼,아메카지 등등 다양한 스타일에 매치</span>할수있다.
          </p>
          <div className={cn({on2},'clickImg')}>
            <img src="images/sec2img1.jpeg" alt="월드투어"/>
            <img src="images/sec2img2.jpeg" alt="월드투어"/>
          </div>
        </div>
      </div>

    </Article2Block>
  );
};

export default Article2;